<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <el-input size="mini" placeholder="请输入客户名称/项目名称" v-model="keyword" clearable style="width: 200px"></el-input>

          <el-select size="mini" v-model="entry_type_name" placeholder="业务类型" clearable>
            <el-option
              v-for="item in business_list"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>

          <el-select size="mini" v-model="from_type" placeholder="合同类型" clearable>
            <el-option label="主营非物业合同" value="主营非物业合同"></el-option>
            <el-option label="其他收入合同" value="其他收入合同"></el-option>
          </el-select>

          <el-date-picker
            size="mini"
            v-model="where_time"
            unlink-panels
            type="monthrange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
          </el-date-picker>

          <el-button size="mini" type="primary" @click="search">搜索</el-button>

          <div style="width: 30px;display: inline-block;"></div>


<!--          - -->
          <el-button size="mini" type="primary" @click="download">导出报表</el-button>
          <el-button size="mini" type="primary" @click="yearDownload">年度报表</el-button>
        </div>

        <div class="table-wrap">
          <el-table ref="elTable" v-if="pageData" v-loading="loading" :data="pageData.list" :border="true" :cell-style="cellStyle">
            <el-table-column label="序号" align="center" fixed="left" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.contract_area !== '合计'" v-text="scope.$index + 1 + (pageData.page - 1) * pageData.pageSize"></span>
              </template>
            </el-table-column>
            <el-table-column prop="contract_area" label="区域" align="center" fixed="left" width="200"></el-table-column>
            <el-table-column prop="contract_leader" label="负责人" align="center" fixed="left" width="80"></el-table-column>
            <el-table-column prop="party_a" label="客户名称" align="center" fixed="left" width="200"></el-table-column>
            <el-table-column prop="project_name" label="项目名称" align="center" fixed="left" width="150"></el-table-column>
            <el-table-column prop="entry_type_name" label="业务类型" align="center" fixed="left" width="80"></el-table-column>
            <el-table-column prop="contract_price" label="合同总价" align="center" fixed="left" width="100"></el-table-column>


            <template v-for="item in month_list">
              <el-table-column prop="month" :label="item" align="center" width="160">
                <el-table-column label="已开票" align="center" width="80">
                <template slot-scope="scope">
                    <span v-if="scope.row.month_value_list[item]['invoiced']>0" style="color: #ff3d00">
                      {{scope.row.month_value_list[item]['invoiced']}}</span>
                    <span v-if="scope.row.month_value_list[item]['invoiced'] ===undefined" style="color: #343436">
                      {{scope.row.month_value_list[item]['invoiced']}}</span>
                    <span v-if="scope.row.month_value_list[item]['invoiced'] ==='0.00'" style="color: #26a803">
                      {{scope.row.month_value_list[item]['invoiced']}}</span>
                </template>
              </el-table-column>
                <el-table-column label="未开票" align="center" width="80">
                  <template slot-scope="scope">
                    <span v-if="scope.row.month_value_list[item]['not_invoice']>0" style="color: #ff3d00">
                      {{scope.row.month_value_list[item]['not_invoice']}}</span>
                    <span v-if="scope.row.month_value_list[item]['not_invoice'] ===undefined" style="color: #343436">
                      {{scope.row.month_value_list[item]['not_invoice']}}</span>
                    <span v-if="scope.row.month_value_list[item]['not_invoice'] ==='0.00'" style="color: #26a803">
                      {{scope.row.month_value_list[item]['not_invoice']}}</span>
            </template>
                </el-table-column>
              </el-table-column>
            </template>

            <el-table-column prop="all_amount" label="累计应收" align="center" width="100"></el-table-column>
            <el-table-column prop="all_invoiced_amount" label="已开票金额" align="center" width="100"></el-table-column>
            <el-table-column prop="all_uninvoiced_amount" label="未开票金额" align="center" width="100"></el-table-column>
            <el-table-column prop="all_diff_amount" label="检验" align="center" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.all_diff_amount===0" style="color: #42a936">{{scope.row.all_diff_amount}}</span>
                <span v-else style="color: #ff3d00">{{scope.row.all_diff_amount}}</span>
              </template>
            </el-table-column>


          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="sizes,prev,pager,next" :total="pageData.total*1" :page-sizes="[20, 50, 100, 200]"
                         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                         @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="download_visible" title="下载进度" width="350" @close="download_visible = false">
      <div>
        <el-progress :percentage="download_progress"></el-progress>
  </div>
    </el-dialog>
  </div>
</template>

<script>

import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";

export default {
  name:"Receivables2",
  components: {AreaTree, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        month:"",
        contract_id:"",
        month_key:"",
        amount:"",
        invoice_amount:"",
        paid_amount:"",
        status:"",
        is_end:"",
        is_invoice:"",
        is_paid:"",
        files:"",
        remarks:"",
      },
      month_value:"",
      business_list:[],
      entry_type_name:"",
      multipleSelection:[],
      f_status:"",
      month_keys:{},
      where_time:"",
      from_type : '',
      // 增加下载进度相关变量
      download_visible : false,
      download_progress : 0,
      cache_key : '',
      cache_page : 1
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    this.month_value=CommonHelp.date("YYYY-MM");
    this.where_time=[CommonHelp.date("YYYY-01"),CommonHelp.date("YYYY-MM")]
    // this.getList()
    this.getBusinessList()
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },

  },
  computed:{
    month_list(){
      var that=this;
      let list=Object.keys(that.month_keys);
      list.sort();
      return list;
    }
  },
  methods: {
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      this.where_time&&(where.where_time=this.where_time);
      if(this.from_type != ''){
        where['c.from_type'] = this.from_type;
      }
      // this.month_value&&(where.month=this.month_value);
      // where['f.status']=this.f_status;
      CommonHelp.get("Receivables2/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.month_keys={};
          res.data.list.map(ret=>{
            ret.is_end=ret.is_end === 1;
            ret.is_invoice=ret.is_invoice === 1;
            ret.is_paid=ret.is_paid === 1;
            let month_keys=ret.month_value_list
            that.month_keys={
              ...that.month_keys,
              ...month_keys
            }
            return ret;
          })
          that.pageData=res.data
          that.$nextTick(() => {
            that.$refs.elTable.doLayout()
          });
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    // 新增下载初始化方法
    download(){
      this.cache_key = '';
      this.cache_page = 1;
      this.download_progress = 0;
      this.download_visible = true;
      this.exportExcel();
    },
    yearDownload(){
      this.cache_key = '';
      this.cache_page = 1;
      this.download_progress = 0;
      this.download_visible = true;
      this.exportExcelYear();
    },
    // 修改导出方法支持进度显示
    exportExcel(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      this.where_time&&(where.where_time=this.where_time);
      if(this.from_type != ''){
        where['c.from_type'] = this.from_type;
      }
      CommonHelp.get("Receivables2/exportExcel",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize,
        cache_key : this.cache_key,
        cache_page : this.cache_page
      },res=>{
        if(res.code) {
          let is_finish = res.data.is_finish;
          if(is_finish){
            that.download_visible = false;
            let url = res.data.url;
            window.open(that.host_url + url)
          }else{
            that.download_progress = ((that.cache_page - 1) / res.data.total * 100).toFixed(2);
            that.cache_key = res.data.cache_key;
            that.cache_page = res.data.cache_page;
            that.exportExcel();
          }
        }
      })
    },
    exportExcelYear(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      this.where_time&&(where.where_time=this.where_time);
      if(this.from_type != ''){
        where['c.from_type'] = this.from_type;
      }
      CommonHelp.get("Receivables2/exportExcelYear",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize,
        cache_key : this.cache_key,
        cache_page : this.cache_page
      },res=>{
        if(res.code) {
          let is_finish = res.data.is_finish;
          if(is_finish){
            that.download_visible = false;
            let url = res.data.url;
            window.open(that.host_url + url)
          }else{
            that.download_progress = ((that.cache_page - 1) / res.data.total * 100).toFixed(2);
            that.cache_key = res.data.cache_key;
            that.cache_page = res.data.cache_page;
            that.exportExcelYear();
          }
        }
      })
    },
    getBusinessList(){
      var that=this;
      CommonHelp.get("Business/getList",{
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.business_list=res.data.list
        }
      })
    },
    cellStyle({row, column, rowIndex, columnIndex}){
      if(columnIndex>5){
        let row_keys=Object.keys(row);
        // console.log(row_keys,row[row_keys[columnIndex]])
        // if(row[row_keys[columnIndex]]===undefined){
        //   return {background:'#090909'}
        // }else if(row[row_keys[columnIndex]]==='0.00'){
        //   return {background:'#039f03'}
        // }else {
        //   return {background:'#f51313'}
        // }
      }
    },
    handleSizeChange(val){
      this.pageData.pageSize = val;
      this.getList();
    },
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/Receivables2.vue